import spinnerHttpRequest from '@/api/spinner-http-request';
import useUserStore from '@/store/user-store';
import {
    PointProvideRequestResI,
    PointRequestHistoryParamsT,
    PointRequestHistoryResI,
    PointRetrieveRequestResI,
} from '@/types/points/api/point-request-history-api-types';
import {storeToRefs} from 'pinia';

const user = useUserStore();
const {isExcelDownloadVerified} = storeToRefs(user); // 엑셀 다운로드 2차인증 여부 플래그

/**
 * @description 포인트 지급/회수 요청내역 조회 API
 * @param params
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/포인트/getRequests
 */
export const getPointRequestHistory = async (
    params: PointRequestHistoryParamsT,
) => {
    const response = await spinnerHttpRequest.get<PointRequestHistoryResI>(
        '/point/requests',
        {
            params,
        },
    );

    return response.data;
};

/**
 * @description 포인트 지급/회수 요청내역 > 목록 엑셀 다운로드 API
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/포인트/loadExcelRequests
 */
export const getPointRequestListExcelFile = async (
    params: PointRequestHistoryParamsT,
    password?: string,
) => {
    const response = await spinnerHttpRequest.post<Blob>(
        '/point/excel/requests',
        {
            // request body
            password: isExcelDownloadVerified.value ? null : password,
        },
        {params, responseType: 'blob'},
    );

    return response.data;
};

/**
 * @description 포인트 지급/회수 요청내역 > 포인트 지급 요청 Modal > 지급 요청 API
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/포인트/provide
 */
export const fetchPointProvideRequest = async (data: FormData) => {
    // FIXME: postForm으로 수정
    const response = await spinnerHttpRequest.post<PointProvideRequestResI>(
        '/point/provide',
        data,
    );

    return response.data;
};

/**
 * @description 포인트 지급/회수 요청내역 > 포인트 회수 요청 Modal > 회수 요청 API
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/포인트/retrieveRequest
 */
export const fetchPointRetrieveRequest = async (data: FormData) => {
    // FIXME: postForm으로 수정
    const response = await spinnerHttpRequest.post<PointRetrieveRequestResI>(
        '/point/retrieve',
        data,
    );

    return response.data;
};
